var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgCalendar(props) {
    return (React.createElement("svg", __assign({ viewBox: '9 0 20 22' }, props),
        React.createElement("g", { fillRule: 'evenodd' },
            React.createElement("path", { fillRule: 'nonzero', d: 'M25.5 3.25h-13A3.75 3.75 0 008.75 7v11a3.75 3.75 0 003.75 3.75h13A3.75 3.75 0 0029.25 18V7a3.75 3.75 0 00-3.75-3.75zm-13 1.5h13A2.25 2.25 0 0127.75 7v11a2.25 2.25 0 01-2.25 2.25h-13A2.25 2.25 0 0110.25 18V7a2.25 2.25 0 012.25-2.25z' }),
            React.createElement("path", { d: 'M12 13h1.6v1.6H12zm3.1 0h1.6v1.6h-1.6z' }),
            React.createElement("path", { d: 'M15.1 13h1.6v1.6h-1.6zm3.1 0h1.6v1.6h-1.6zm6.2.1H26v1.6h-1.6zm-3.1 0h1.6v1.6h-1.6zm-9.3 3h1.6v1.6H12zm3.1 0h1.6v1.6h-1.6zm3.1 0h1.6v1.6h-1.6zm6.2.1H26v1.6h-1.6zm-3.1 0h1.6v1.6h-1.6zm3.1-6.2H26v1.6h-1.6zm-3.1 0h1.6v1.6h-1.6z' }),
            React.createElement("path", { fillRule: 'nonzero', d: 'M13 .75a.75.75 0 01.743.648l.007.102v6a.75.75 0 01-1.493.102L12.25 7.5v-6A.75.75 0 0113 .75zm12 0a.75.75 0 01.743.648l.007.102v6a.75.75 0 01-1.493.102L24.25 7.5v-6A.75.75 0 0125 .75z' }))));
}
export default SvgCalendar;
//# sourceMappingURL=Calendar.js.map